import { css } from '@linaria/core';
import theme from '../../../theme';

export const variants = {
  success: css``,
  warning: css``,
  error: css``,
};

export const input = css`
  background: white;
  color: ${theme.colors.neutral['99']};
  font-size: 16px;
  height: var(--control-height, 36px);
  box-shadow: ${theme.elevation.peoople};
  border-radius: 12px;
  padding: 14px 21px;
  width: 100%;
  border-width: 0px;
  border-style: solid;
  &:focus {
    border-color: ${theme.colors.neutral['30']};
  }

  &:hover:not([disabled]) {
    border-color: ${theme.colors.neutral['30']};
  }

  &::placeholder,
  &.placeholder {
    color: ${theme.colors.neutral['60']};
    font-weight: 400;
    font-style: italic;
  }

  outline: none;
  &:not(input):not(textarea):focus-visible {
    border-color: ${theme.colors.primary['60']};
  }

  &[disabled] {
    border-color: ${theme.colors.neutral['30']};
    cursor: not-allowed;
    background: ${theme.colors.neutral['30']};
    color: ${theme.colors.neutral['60']};
    &::placeholder,
    &.placeholder {
      color: ${theme.colors.neutral['60']};
    }
  }

  &.${variants.success} {
    border-color: ${theme.colors.success['95']};
    &:hover:not([disabled]) {
      border-color: ${theme.colors.success['95']};
    }

    &:focus {
      border-color: ${theme.colors.success['95']};
    }
  }

  &.${variants.warning} {
    border-color: ${theme.colors.warning['80']};
    &:hover:not([disabled]) {
      border-color: ${theme.colors.warning['80']};
    }

    &:focus {
      border-color: ${theme.colors.warning['80']};
    }
  }

  &.${variants.error} {
    border-color: ${theme.colors.error['95']};
    &:hover:not([disabled]) {
      border-color: ${theme.colors.error['95']};
    }

    &:focus {
      border-color: ${theme.colors.error['95']};
    }
  }
`;
